export default __webpack_public_path__ + "preview-add-manually.3d9cf0f6.svg";